import { render, staticRenderFns } from "./RevenueByCustomerPage.vue?vue&type=template&id=0ef41b06&scoped=true&"
import script from "./RevenueByCustomerPage.vue?vue&type=script&lang=js&"
export * from "./RevenueByCustomerPage.vue?vue&type=script&lang=js&"
import style0 from "./RevenueByCustomerPage.vue?vue&type=style&index=0&id=0ef41b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef41b06",
  null
  
)

export default component.exports